export default __webpack_public_path__ + "static/media/Antenna.558f303d.pdf";